import { Link } from 'react-router-dom';
import { siteConfig } from '../config/site';

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <Link className="brand brand-light" to="/">
            <span className="brand-mark" aria-hidden="true">○</span>
            <span>{siteConfig.organizationName}</span>
          </Link>
          <p className="footer-description">{siteConfig.shortDescription}</p>
        </div>
        <nav aria-label="Footer navigation">
          <h2 className="footer-heading">Explore</h2>
          <ul className="footer-links">
            <li><Link to="/about">About</Link></li>
            <li><Link to="/projects">Our work</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>
        <div>
          <h2 className="footer-heading">Stay connected</h2>
          <p>{siteConfig.email}</p>
          <p className="placeholder-note">Service area: [To be confirmed]</p>
        </div>
      </div>
      <div className="container footer-bottom">
        <p>© {new Date().getFullYear()} {siteConfig.organizationName}. All rights reserved.</p>
        <p>Nonprofit status: [To be confirmed]</p>
      </div>
    </footer>
  );
}
